'use client';
import { arrayOf } from '@s7/utils';

const isIncludesSafe = (a, b)=>{
    return b !== undefined && arrayOf(a).includes(b);
};

export { isIncludesSafe };
//# sourceMappingURL=isIncludesSafe.js.map
